import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, normalizeClass as _normalizeClass, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-22474e2e"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "flex-grow flex-col grid grid-cols-1 sm:grid-cols-9" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "sm:col-span-1 text-center self-start flex flex-row px-4 sm:p-8 mb-8 sm:mb-0 items-center sm:items-start justify-between" }, [
  /*#__PURE__*/_createElementVNode("img", {
    src: "/img/gograss/logo.png",
    class: "w-1/3 inline-block sm:hidden",
    alt: "Logo"
  })
], -1))
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "sm:col-span-5 flex flex-row items-center" }, null, -1))
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "sm:col-span-3 hidden sm:block justify-end items-center bg-white min-h-full p-12 pt-8 pb-0" }, [
  /*#__PURE__*/_createElementVNode("img", {
    src: "/img/gograss/logo.png",
    class: "max-h-24 max-w-36",
    alt: "Logo"
  })
], -1))
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "sm:col-span-1" }, null, -1))
const _hoisted_6 = { class: "sm:col-span-5 main-content p-4" }
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h2", { class: "text-5xl font-bold text-white" }, [
  /*#__PURE__*/_createTextVNode(" Welcome to the "),
  /*#__PURE__*/_createElementVNode("img", {
    class: "inline-block",
    src: "img/gograss/gograss-text.png",
    alt: "Go Grass"
  }),
  /*#__PURE__*/_createElementVNode("br"),
  /*#__PURE__*/_createTextVNode(" interactive experience! ")
], -1))
const _hoisted_8 = ["innerHTML"]
const _hoisted_9 = ["innerHTML"]
const _hoisted_10 = ["innerHTML"]
const _hoisted_11 = ["value"]
const _hoisted_12 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "sm:col-span-3 flex flex-col justify-end items-start bg-white" }, [
  /*#__PURE__*/_createElementVNode("img", {
    src: "/img/gograss/grass.jpg",
    class: "max-w-full md:w-2/3 max-h-50vh",
    alt: "Logo"
  })
], -1))
const _hoisted_13 = { class: "flex flex-col sm:flex-row mt-auto bg-white absolute bottom-0 left-0 right-0 p-4 text-black text-xs font-light" }
const _hoisted_14 = { class: "flex flex-row flex-6 items-center" }
const _hoisted_15 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: "img/eu.logo.png",
  alt: "EU Flag",
  class: "h-12 align-top mr-2 w-auto"
}, null, -1))
const _hoisted_16 = { class: "flex flex-col" }
const _hoisted_17 = ["innerHTML"]
const _hoisted_18 = ["innerHTML"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_ActionButton = _resolveComponent("ActionButton")!
  const _component_ScreenWrapper = _resolveComponent("ScreenWrapper")!

  return (_openBlock(), _createElementBlock("section", {
    class: _normalizeClass(["screen-content relative p-4 sm:p-0", _ctx.config.classes?.wrapperClasses])
  }, [
    _createVNode(_component_ScreenWrapper, {
      "class-name": "pt-0 pb-12 bg-project text-white",
      next: _ctx.next,
      screen: _ctx.screen,
      "hide-arrow": ""
    }, {
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_1, [
          _hoisted_2,
          _hoisted_3,
          _hoisted_4,
          _hoisted_5,
          _createElementVNode("div", _hoisted_6, [
            _hoisted_7,
            _createElementVNode("p", {
              class: "mt-8",
              innerHTML: _ctx.$t(_ctx.config.textPart1, {name: _ctx.state.nickname.value})
            }, null, 8, _hoisted_8),
            _createElementVNode("p", {
              class: "mt-8",
              innerHTML: _ctx.$t(_ctx.config.textPart2, {name: _ctx.state.nickname.value})
            }, null, 8, _hoisted_9),
            _createElementVNode("p", {
              class: "mt-8",
              innerHTML: _ctx.$t(_ctx.config.textPart3, {name: _ctx.state.nickname.value})
            }, null, 8, _hoisted_10),
            _createElementVNode("input", {
              type: "text",
              value: _ctx.state.nickname.value,
              onChange: _cache[0] || (_cache[0] = ($event: any) => (_ctx.state.setNickname($event.target.value))),
              placeholder: "Visitor",
              class: "mt-4 border border-gray-300 p-2 rounded-lg w-full sm:w-auto text-black"
            }, null, 40, _hoisted_11),
            _createVNode(_component_ActionButton, {
              text: "buttons.start",
              onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.next())),
              class: _normalizeClass(["mt-8 mx-auto sm:mx-0 block action-button-primary", _ctx.config.classes?.buttonClasses])
            }, null, 8, ["class"])
          ]),
          _hoisted_12
        ])
      ]),
      _: 1
    }, 8, ["next", "screen"]),
    _createElementVNode("div", _hoisted_13, [
      _createElementVNode("div", _hoisted_14, [
        _hoisted_15,
        _createElementVNode("div", _hoisted_16, [
          _createElementVNode("p", {
            innerHTML: _ctx.$t('GOGRASS_INTRO.eu-footer')
          }, null, 8, _hoisted_17),
          _createElementVNode("p", {
            innerHTML: _ctx.$t(_ctx.config.textPart4)
          }, null, 8, _hoisted_18)
        ])
      ])
    ])
  ], 2))
}